<dx-popup
  [(visible)]="showModal"
  [showTitle]="false"
  [width]="700"
  [height]="'auto'"
  [maxHeight]="'95vh'"
  [dragEnabled]="false"
  [hideOnOutsideClick]="true"
  (onHiding)="close()"
  [wrapperAttr]="{ 
    class: 'select-standard-category' 
  }"
>
  <div 
    *dxTemplate="let data of 'content'" 
    class="standard-category-modal"
  >
    <div class="standard-category-modal-header">
      <div class="standard-category-modal-header-content">
        @if(isAssociatedCategory) {
          <div class="standard-category-modal-kicker">
            {{ 'STANDARD-CATEGORIES.SUBSCRIPTION-MAPPING' | translate }}
          </div>
          <div class="standard-category-modal-title">
            {{ 'STANDARD-CATEGORIES.LINK-STANDARD-CATEGORY' | translate }}
          </div>
          <div class="standard-category-modal-subtitle">
            {{ 'STANDARD-CATEGORIES.MAP-STANDARD-CATEGORY' | translate }}
          </div>
        } @else {
          <div class="standard-category-modal-kicker">
            {{ 'STANDARD-CATEGORIES.STANDARD-PORTFOLIO' | translate }}
          </div>
          <div class="standard-category-modal-title">
            {{ 'STANDARD-CATEGORIES.SELECT-STANDARD-CATEGORY' | translate }}
          </div>
          <div class="standard-category-modal-subtitle">
            {{ 'STANDARD-CATEGORIES.PREFILLS-STANDARD-CATEGORY-2' | translate }}
          </div>
        }
      </div>

      <dx-button
        icon="close"
        stylingMode="text"
        (onClick)="close()">
      </dx-button>
    </div>

    <div class="standard-category-selector">
      <div class="search-container">
        <dx-text-box
          [placeholder]="'STANDARD-CATEGORIES.SEARCH-STANDARD-CATEGORIES' | translate"
          mode="search"
          [value]="search"
          valueChangeEvent="keyup"
          (onValueChanged)="onSearchChanged($event)">
        </dx-text-box>
      </div>

      <div 
        class="used-container" 
        *ngIf="showUsedStandardCategories && filteredUsedStandardCategories.length"
      >
        <div class="used-title-container">
          <div class="used-title">
            {{ 'STANDARD-CATEGORIES.USED-BY-YOU' | translate }}
          </div>

          <div class="most-used-text">
            {{ filteredUsedStandardCategories.length }}
            {{ 'COMMON.CATEGORIES' | translate }}
            ·
            {{ 'STANDARD-CATEGORIES.MOST-USED-FIRST' | translate }}
          </div>
        </div>

        <div class="used-categories-container">
          <div
            *ngFor="
              let category of (
                showMoreUsedStandardCategories
                  ? filteredUsedStandardCategories
                  : visibleStandardCategories
              )
            "
            class="used-category"
            (click)="selectUsedStandardCategory(category)"
            [ngClass]="category.selected ? 'selected-category' : ''"
          >
            {{ category.name }}
          </div>

          @if (filteredUsedStandardCategories.length > maxVisibleStandardCategories) {
            @if (!showMoreUsedStandardCategories) {
              <div
                class="more-button"
                (click)="toggleShowMoreUsedStandardCategories()"
              >
                {{ 'COMMON.MORE' | translate }}
                ({{ filteredUsedStandardCategories.length - maxVisibleStandardCategories }})
              </div>
            } @else {
              <div
                class="less-button"
                (click)="toggleShowMoreUsedStandardCategories()"
              >
                {{ 'COMMON.LESS' | translate }}
              </div>
            }
          }
        </div>
      </div>

      <div class="tabs-container">
        <dx-tabs
          [items]="tabs"
          [(selectedIndex)]="selectedTab"
          (onItemClick)="onTabChanged($event)"
          itemTemplate="tabTemplate"
        >
          <div *dxTemplate="let tab of 'tabTemplate'">
            <div class="standard-category-tab">
              <span>{{ tab.text }}</span>
              <span class="standard-category-tab-count">
                {{ tab.count }}
              </span>
            </div>
          </div>
        </dx-tabs>
      </div>
    </div>

    <div class="standard-category-tree">
      <dx-tree-view
        [items]="displayedTree"
        displayExpr="text"
        itemsExpr="items"
        [selectionMode]="selectionMode"
        [selectByClick]="true"
        [showCheckBoxesMode]="selectionMode === 'multiple' ? 'normal' : 'none'"
        (onItemClick)="onStandardCategoryClick($event.itemData)"
        (onItemSelectionChanged)="onStandardCategorySelectionChanged($event.itemData)"
        [selectNodesRecursive]="false"
        itemTemplate="treeItem"  
        (onItemRendered)="onItemRendered($event)"
      >
        <div *dxTemplate="let item of 'treeItem'">
          <div class="tree-item">
            <span>{{ item.text }}</span>
            <span
              *ngIf="item.isGroup"
              class="tree-item-count"
            >
              {{ item.count }}
            </span>
          </div>
        </div>
      </dx-tree-view>
    </div>
    <div 
      class="standard-category-modal-footer" 
      *ngIf="selectionMode === 'multiple'"
    >
      <dx-button
        [text]="'COMMON.CANCEL' | translate"
        type="default"
        (onClick)="close()"
      ></dx-button>

      <dx-button
        [disabled]="selectedCategories.length === 0"
        [text]="'COMMON.SELECT' | translate"
        type="normal"
        (onClick)="confirmSelection()"
      ></dx-button>
    </div>
  </div>
</dx-popup>